import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";

export function ConnectWizardDialog({
  open, onOpenChange, wizardStep, onWizardStepChange,
  connForm, onConnFormChange, testResult, testing,
  onTest, onConfirm, company, companyId,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="connect-wizard">
        <DialogHeader>
          <DialogTitle>Collega JOBTIMEHR — passo {wizardStep} di 2</DialogTitle>
          <DialogDescription>
            {wizardStep === 1
              ? "Configura endpoint e credenziali OAuth2 (client credentials). Il secret non verrà mai mostrato dopo il salvataggio."
              : "Verifica il mapping aziendale e conferma la connessione."}
          </DialogDescription>
        </DialogHeader>
        {wizardStep === 1 ? (
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label>Base URL API</Label>
              <Input value={connForm.base_url} onChange={(e) => onConnFormChange({ ...connForm, base_url: e.target.value })} data-testid="jt-field-base-url" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <Label>Client ID *</Label>
                <Input value={connForm.client_id} onChange={(e) => onConnFormChange({ ...connForm, client_id: e.target.value })} data-testid="jt-field-client-id" />
              </div>
              <div className="space-y-1.5">
                <Label>Client Secret *</Label>
                <Input type="password" value={connForm.client_secret} onChange={(e) => onConnFormChange({ ...connForm, client_secret: e.target.value })} data-testid="jt-field-client-secret" />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label>Company External ID (JOBTIMEHR) *</Label>
              <Input value={connForm.company_external_id} onChange={(e) => onConnFormChange({ ...connForm, company_external_id: e.target.value })}
                placeholder="UUID azienda in JOBTIMEHR" data-testid="jt-field-external-id" />
              <p className="text-xs text-slate-500">L'autorizzazione tenant è verificata server-side da JOBTIMEHR: aziende non abilitate → 403.</p>
            </div>
            {testResult && (
              <div className={`rounded-md border p-3 text-sm ${testResult.result === "SUCCESS" ? "bg-green-50 border-green-200 text-green-900" : "bg-red-50 border-red-200 text-red-900"}`}
                data-testid="jt-test-result">
                <p className="font-semibold">{testResult.result}</p>
                {testResult.result === "SUCCESS"
                  ? <p className="text-xs mt-1">API {testResult.api_version} · {(testResult.capabilities || []).length} capability rilevate. Prosegui al passo 2.</p>
                  : <p className="text-xs mt-1">{testResult.detail || "Verifica credenziali, endpoint e companyExternalId."}</p>}
              </div>
            )}
            <DialogFooter>
              <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="jt-wizard-cancel">Annulla</Button>
              <Button onClick={onTest} disabled={testing || !connForm.client_id || !connForm.client_secret || !connForm.company_external_id}
                className="bg-green-700 hover:bg-green-800" data-testid="jt-test-connection-btn">
                {testing ? "Test in corso…" : "Testa connessione"}
              </Button>
            </DialogFooter>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="rounded-md border border-green-200 bg-green-50 p-3 text-sm text-green-900" data-testid="jt-mapping-confirm">
              <p className="font-semibold mb-1">Conferma company mapping</p>
              <p className="text-xs">ESG: <span className="font-semibold">{company?.name || companyId}</span></p>
              <p className="text-xs">JOBTIMEHR: <span className="font-mono">{connForm.company_external_id}</span></p>
              <p className="text-xs mt-1">Nessuna sincronizzazione cross-company: ogni risposta viene validata contro questo identificativo.</p>
            </div>
            <div className="space-y-1.5">
              <Label>Frequenza sincronizzazione</Label>
              <Select value={connForm.sync_frequency} onValueChange={(v) => onConnFormChange({ ...connForm, sync_frequency: v })}>
                <SelectTrigger data-testid="jt-sync-frequency"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="MANUAL">Manuale (consigliata per reporting ESG)</SelectItem>
                  <SelectItem value="DAILY">Giornaliera</SelectItem>
                  <SelectItem value="WEEKLY">Settimanale</SelectItem>
                  <SelectItem value="MONTHLY">Mensile</SelectItem>
                </SelectContent>
              </Select>
              <p className="text-xs text-slate-500">Nessun polling ad alta frequenza: i dati ESG non richiedono sync in tempo reale.</p>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => onWizardStepChange(1)} data-testid="jt-wizard-back">Indietro</Button>
              <Button onClick={onConfirm} className="bg-green-700 hover:bg-green-800" data-testid="jt-confirm-connect">
                Conferma e collega
              </Button>
            </DialogFooter>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
